const MentorMessage = () => {
  return <>Mentor Messages Page</>;
};

export default MentorMessage;
